export default () => ({
  searchField: {
    marginLeft: 10,
    marginRight: 10
  }
})
